import React from "react";
import numeral from "numeral";
import DateHelper from "../DateHelper/DateHelper";

class RateSelect extends React.Component {

	constructor(props) {
		super(props);
    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00'
    };
	}

	componentDidMount() {
		this.initSelect2()
	}

	componentDidUpdate(prevProps) {
		if(this.props.rate == null && prevProps.rate != null && `#rate-select-${this.props.selectID}`) {
			$(`#rate-select-${this.props.selectID}`).val('').trigger('change')
		}
	}

  initSelect2 () {
    var self = this;

    if (`#rate-select-${this.props.selectID}`) {
      $(`#rate-select-${this.props.selectID}`).select2({
        ajax: {
          url: `${this.props.remote_path ? this.props.remote_path : '/admin/rates_remote'}`,
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40,
              all_special_rates: self.props.all_special_rates ? self.props.all_special_rates : null,
							promo_code: self.props.promo_code ? self.props.promo_code : null,
              room_type_id: self.props.room_type ? self.props.room_type.id : null,
              start_date: self.props.start_date ? DateHelper.printDateToScreen(self.props.start_date, 'yyyy-MM-dd') : null,
              end_date: self.props.end_date ? DateHelper.printDateToScreen(self.props.end_date, 'yyyy-MM-dd') : null,
              group_contract_id: self.props.group_contract ? self.props.group_contract.id : null,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: true
        },
        allowClear: false,
        escapeMarkup: function (markup) {
          return markup;
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (rate) {
          return self.processRate(rate);
        },
        templateSelection: function (rate) {
          return self.processRate(rate);
        }
      }).on('select2:unselect', function () {
        self.props.onChange(null);
      }).on('select2:select', function (selection) {
        self.props.onChange(selection.params.data);
      });
    }
  }

  render() {
    return (
      <div className="rate">
        <select className="form-control" id={`rate-select-${this.props.selectID}`} style={{width: '100%', minHeight: 33}}>
          {this.props.rate ? <option value={this.props.rate.id}>{this.processRate(this.props.rate)}</option> : null}
        </select>
        {this.renderFieldError()}
      </div>
    );
  }

  processRate(rate) {
		if (!rate.loading && rate.code && this.props.add_charge) {
			return rate.code + ' (' + rate.rate_type + ')'
    } else if (!rate.loading && rate.code && this.props.ruRate) {
      return rate.name + ' (' + rate.code + ')'
    }else if (!rate.loading && rate.code) {
  		return rate.code + ', ' + (rate.description && rate.description != '' ? rate.description + ', ' : '') + (rate.average_amount ? '$' + numeral(rate.average_amount / 100).format(this.state.numberFormat) : null) + ' ' + I18n.t('avg_per_night');
  	} else {
  		return rate.text;
  	}
  }

  renderFieldError() {
    if (this.props.hasError) {
      if (this.props.hasError.includes('has-errors')) {
        if ($(".rate").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && !$(".rate").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
          $(".rate").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className += ` has-errors`
        }
      }
      if (!this.props.hasError.includes('has-errors')) {
        if ($(".rate").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && $(".rate").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
          var select = $(".rate").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0]
          select.className = select.className.replace(/has-errors/g, "")
        }
      }
    };
  }

}

export default RateSelect
